var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#067BC2",
    fillRule: "evenodd",
    d: "M8.012 7l5.435 5.435a.78.78 0 0 1 0 1.106l.094-.094a.778.778 0 0 1-1.106 0L7 8.012l-5.435 5.435a.78.78 0 0 1-1.106 0l.094.094a.777.777 0 0 1 0-1.106L5.987 7 .553 1.565a.78.78 0 0 1 0-1.106L.46.553a.777.777 0 0 1 1.106 0L7 5.988 12.435.553a.78.78 0 0 1 1.106 0L13.446.46a.777.777 0 0 1 .001 1.106L8.012 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseSmall);
export default __webpack_public_path__ + "static/media/icon_close_small.e1e74c21b70a1c366e45d41f2539e7a9.svg";
export { ForwardRef as ReactComponent };